import { render, staticRenderFns } from "./AccountResendActivationSuccess.vue?vue&type=template&id=5d71a1f9&scoped=true&"
import script from "./AccountResendActivationSuccess.vue?vue&type=script&lang=js&"
export * from "./AccountResendActivationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AccountResendActivationSuccess.vue?vue&type=style&index=0&id=5d71a1f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71a1f9",
  null
  
)

export default component.exports